import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Storage } from "@ionic/storage";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  firstTime: boolean;
  slideOpts = {
    initialSlide: 1,
    speed: 400,
  };
  constructor(private storage: Storage, private router: Router) {
    this.saveFirstTimeLoad(); //call this method, everytime this service is in session
  }

  saveFirstTimeLoad(): void {
    this.storage.set("firstTime", true);
  }

  isFirstTimeLoad() { //run function on call
    this.storage.get("firstTime").then((result) => {
      if (result != null) {
        this.firstTime = false;
        this.router
          .navigateByUrl("/home", { replaceUrl: true })
          .then(() => this.storage.set("firstTime", false));
      } else {
        this.firstTime = true;
        this.storage.set("ion_did_tutorial", false); //update the localstorage ion_did_tutorial variable
        this.router.navigateByUrl("/tutorial"); //redirect to the tutorial page
      }
    });
  }
}
